import { paths } from "helpers/paths";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/legalPersons";
import Form from "./form";
import List from "./list";

export default function LegalPersons(props) {
    const { location, history } = props;
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={paths.legalPersonsShow("list")}
                    render={() => <Redirect to={paths.legalPersons} />}
                />
                <Route
                    exact
                    path={paths.legalPersonsNew}
                    render={() => <Form {...props} transition="full" title="Добавить организацию" source={source} />}
                />
                <Route
                    path={paths.legalPersonsShow(":id")}
                    render={(props) => <Form {...props} transition="full" source={source} />}
                />
                <Route
                    path={paths.legalPersons}
                    render={(props) => <List {...props} back={() => history.push(paths.cargoOwners)} source={source} />}
                />
            </Switch>
        </div>
    );
}
